/* BLUND — Product page interactions */
(function () {
  "use strict";

  /* Gallery thumbnails */
  var main = document.getElementById("vita-pdp-main");
  document.querySelectorAll("[data-vita-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (main) main.src = btn.getAttribute("data-vita-thumb");
      document.querySelectorAll(".vita-pdp__thumb").forEach(function (t) { t.classList.remove("is-active"); });
      btn.classList.add("is-active");
    });
  });

  /* Quantity stepper */
  var qtyWrap = document.querySelector("[data-vita-qty]");
  if (qtyWrap) {
    var input = qtyWrap.querySelector(".vita-qty__input");
    qtyWrap.querySelector("[data-vita-qty-minus]").addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    qtyWrap.querySelector("[data-vita-qty-plus]").addEventListener("click", function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  }

  /* Variant selection */
  var variants = window.__vitaVariants || [];
  var form = document.getElementById("vita-product-form");
  var idField = form && form.querySelector("[data-vita-variant-id]");
  var priceEl = document.querySelector("[data-vita-price] .vita-pdp__price-now");
  var stickyPrice = document.querySelector("[data-vita-sticky-price]");
  var atcBtn = document.querySelector("[data-vita-atc]");
  var atcText = document.querySelector("[data-vita-atc-text]");

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency", currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "EUR"
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function selectedOptions() {
    return Array.prototype.map.call(document.querySelectorAll("[data-vita-option]"), function (s) { return s.value; });
  }

  function onOptionChange() {
    if (!variants.length) return;
    var opts = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    });
    if (!match) return;
    if (idField) idField.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);
    if (stickyPrice) stickyPrice.textContent = money(match.price);
    if (atcBtn) atcBtn.disabled = !match.available;
    if (atcText) atcText.textContent = match.available
      ? (atcText.getAttribute("data-available") || atcText.textContent)
      : (atcText.getAttribute("data-soldout") || "Sold Out");
  }
  document.querySelectorAll("[data-vita-option]").forEach(function (s) { s.addEventListener("change", onOptionChange); });

  /* Sticky mobile ATC: show after the main ATC scrolls out of view */
  var sticky = document.querySelector("[data-vita-sticky-atc]");
  var anchor = document.querySelector("[data-vita-atc]");
  if (sticky && anchor && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.hidden = e.isIntersecting; });
    }, { rootMargin: "0px 0px -40% 0px" });
    io.observe(anchor);
  }
})();
